export default __webpack_public_path__ + "static/MilanLogoMWeb-815e9dc71e15d1499f7bdade02cb03ef.svg";